import { Partner } from '../types/api';

/**
 * Заполненность карточки заведения.
 *
 * Считает сервер: `GET /api/partner/profile` → `data.completeness`
 * (БП 5.1). Раньше девять пунктов собирались здесь, из уже загруженного
 * профиля, — работало, но правило заполненности это свойство продукта, а не
 * одного клиента: приложение и админка обязаны видеть то же число.
 *
 * Здесь остался только маппинг ответа в форму, которую ждут панель и шапка.
 */
export interface CompletenessItem {
  key: string;
  label: string;
  /** Короткая подсказка справа: «готово», «3 позиции», «не заполнено». */
  hint: string;
  done: boolean;
  /** Обязательный пункт — без него заведение не активируется. */
  required: boolean;
}

export interface Completeness {
  items: CompletenessItem[];
  doneCount: number;
  percent: number;
}

const EMPTY: Completeness = { items: [], doneCount: 0, percent: 0 };

export function getCompleteness(partner: Partner | null): Completeness {
  const source = partner?.completeness;

  if (!source) {
    // Профиль ещё не загружен — рисуем пустой чек-лист, а не выдуманный процент.
    return EMPTY;
  }

  return {
    items: source.items,
    doneCount: source.done_count,
    percent: source.percent,
  };
}
